// import { Mstr_Show } from '@app/types/show.type';
import { Mstr_Show } from '@feature/types/show.type';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENV } from "@app/constants/env";
import { MyDashboardShowEntity, MyShows } from '@feature/types/exhibitor.show.type';
import { ExhibitorEventForm } from '@feature/types/exhibitor.event.type';
 import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { getToken } from '@app/helpers/authProvider';


const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.SHOW_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;

  if (typeof args === 'string') {
    args = { url: args };
  }

  try {
    const token = await getToken();
    if (token) {
      const headers =
        (args as FetchArgs).headers instanceof Headers
          ? (args as FetchArgs).headers
          : new Headers((args as FetchArgs).headers);

      headers.set('Authorization', `Bearer ${token}`);
      (args as FetchArgs).headers = headers;
    }

    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401 && token) {
      // refresh token flow could go here
    }

    return result;
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};
export const showApi = createApi({
  reducerPath: 'showApi',
  baseQuery: authBaseQuery,
  tagTypes: ['Show'],
  endpoints: (builder) => ({
    getAllShows: builder.query<Mstr_Show[], { user_id: number, showId: number }>({
      query: ({ user_id, showId }) => `/Shows/GetAllShowForDashboardList/${user_id}/${showId}`,
      providesTags: ['Show'],
    }),
    getShowsForDDL: builder.query<Mstr_Show[], { user_id: number }>({
      query: ({ user_id }) => `/Shows/GetAllShowsForTopDDList/${user_id}`,
      providesTags: ['Show'],
    }),
    addShow: builder.mutation<void, Mstr_Show>({
      query: (show) => ({
        url: '/Shows/AddShow',
        method: 'POST',
        body: show,
      }),
      invalidatesTags: ['Show'],
    }),
    updateShow: builder.mutation<void, Mstr_Show>({
      query: (show) => ({
        url: `/Shows/UpdateShow/${show.Mstr_Show_ID}`,
        method: 'PUT',
        body: show,
      }),
      invalidatesTags: ['Show'],
    }),
    deleteShow: builder.mutation<void, number>({
      query: (id) => ({
        url: `/Shows/DeleteShow/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Show'],
    }),
     getExhibitorShows: builder.query<MyShows[], { user_id: number }>({
      query: ({ user_id }) => `/Shows/GetAllExhibitorShows?userID=${user_id}`,
      providesTags: ['Show'],
    }),
     getExhibitorDashboardShowData: builder.query<MyDashboardShowEntity, { show_id: number, user_id: number }>({
      query: ({ user_id, show_id }) => `/Shows/GetExhibitorDashboardShowData?userId=${user_id}&showId=${show_id}`,
      providesTags: ['Show'],
    }),
     getExhibitorDashboardEventInfoData: builder.query<ExhibitorEventForm[], { show_id: number }>({
      query: ({ show_id }) => `/Shows/GetAllExhibitorInfoForms?showId=${show_id}`,
      providesTags: ['Show'],
    }),
    
     getExhibitorDashboardEventBookingData: builder.query<ExhibitorEventForm[], { show_id: number, user_id:number }>({
      query: ({ show_id, user_id }) => `/Shows/GetAllExhibitorBookingForms?userId=${user_id}&showId=${show_id}`,
      providesTags: ['Show'],
    }),
     getExhibitorOrderSummaryData: builder.query<ExhibitorEventForm[], { show_id: number, user_id:number }>({
      query: ({ show_id, user_id }) => `/Shows/GetAllExhibitorOrderSummaryData?userId=${user_id}&showId=${show_id}`,
      providesTags: ['Show'],
    }),
  }),
});

export const {
  useGetAllShowsQuery,
  useAddShowMutation,
  useUpdateShowMutation,
  useDeleteShowMutation,
  useGetShowsForDDLQuery,
  useGetExhibitorShowsQuery,
  useGetExhibitorDashboardShowDataQuery, 
  useGetExhibitorDashboardEventInfoDataQuery,
  useGetExhibitorDashboardEventBookingDataQuery,
  useGetExhibitorOrderSummaryDataQuery, 
} = showApi;
